import { render, staticRenderFns } from "./Spaceplan.vue?vue&type=template&id=16ffba5c&scoped=true&"
import script from "./Spaceplan.vue?vue&type=script&lang=js&"
export * from "./Spaceplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ffba5c",
  null
  
)

export default component.exports